import {Component, Input, OnInit} from '@angular/core';
import {EquipmentControlService} from '../../services/equipment-control.service';
import {AjaxDownloadService} from '@components/ajax-download-noty/ajax-download.service';
import {CardApiService} from '@modules/equipment-card/services/card.api.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {EventsService} from '@services/events.service';
import {environment} from '@environments/environment';

@Component({
    selector: 'app-documents-generation-menu',
    templateUrl: './documents-generation-menu.component.html',
    styleUrls: ['./documents-generation-menu.component.scss']
})
export class DocumentsGenerationMenuComponent implements OnInit {
    constructor(
        private controlService: EquipmentControlService,
        private ajaxDownloadService: AjaxDownloadService,
        private cardApi: CardApiService,
        private eventsService: EventsService,
    ) {
    }

    @Input() equipmentIds: number[] = [];

    public permissions = UserNamespace.Permission;

    ngOnInit() {
    }

    showCalibrationDialog() {
        this.controlService.showCalibrationRequestDialog$.next();
    }

    generateListDocument(withDocuments = false) {
        this.ajaxDownloadService.do({
            url: this.cardApi.generateListDocumentUrl,
            taskName: 'Список оборудования' + (withDocuments ? ' с копиями' : ''),
            method: 'post',
            data: {
                ids: this.equipmentIds,
                format: withDocuments ? 2 : 1
            }
        });
    }

    generateCardDocument() {
        this.cardApi.post({
            url: this.cardApi.validateCardDocumentUrl,
            dataBody: {
                ids: this.equipmentIds,
            }
        }).subscribe(() => {
            this.ajaxDownloadService.do({
                url: this.cardApi.generateCardDocumentUrl,
                taskName: 'Учетные карточки',
                method: 'post',
                data: {
                    ids: this.equipmentIds,
                }
            });
        }, (errors: string[]) => {
            let message = 'Возникла ошибка при формировании учетных карточек';

            if (errors && errors.length) {
                message = errors.join('<br>');
            }

            this.eventsService.showNoty({
                type: 'warning',
                content: message,
                controls: [
                    {
                        title: 'Сообщить об ошибке',
                        href: environment.technicalSupportUrl
                    }
                ]
            });
        });
    }
}
